.container {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;

  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }
  .content {
    display: flex;
    flex: 1;

    .resultsCount {
      font-family: var(--font-family__heading);
      font-size: 12px;
      color: rgba(0, 0, 0, 0.87);
      margin-right: 17px;
      padding-top: 2px;
      white-space: nowrap;
      display: block;
      margin-bottom: 10px;
    }

    .tableWrapper {
      flex: 1;
      // in conjunction with fix for firefox th/td z-index in table.scss
      .scrollTable > div {
        z-index: 101;
      }
    }
  }
}

.circularProgress {
  position: fixed;
  top: 60vh;
  left: 50%;
}
